import { render, staticRenderFns } from "./Save.vue?vue&type=template&id=646465a9&scoped=true&"
import script from "./Save.vue?vue&type=script&lang=js&"
export * from "./Save.vue?vue&type=script&lang=js&"
import style0 from "./Save.vue?vue&type=style&index=0&id=646465a9&prod&scoped=true&lang=scss&"
import style1 from "./Save.vue?vue&type=style&index=1&id=646465a9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646465a9",
  null
  
)

export default component.exports